"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.mapCanonicalDestinationToTrackableDestination = exports.mapSearchControlTravelDestinationsToSearchCriteriaInputTravelDestinations = exports.mapFormTravelDestinationToSearchCriteriaInputTravelDestination = exports.mapSearchControlTravelDestinationsToFormTravelDestination = exports.mapCanonicalDestinationToInput = exports.mapCanonicalDestinationToIDs = exports.mapTravelDestinationObjectToInput = exports.mapTravelDestinationObjectToCanonical = exports.concatDestinationSections = void 0;
const filter_1 = __importDefault(require("lodash/fp/filter"));
const join_1 = __importDefault(require("lodash/fp/join"));
const pipe_1 = __importDefault(require("lodash/fp/pipe"));
const uniq_1 = __importDefault(require("lodash/fp/uniq"));
const graphql_types_1 = require("@hotelplan/graphql.types");
exports.concatDestinationSections = (0, pipe_1.default)((0, filter_1.default)(Boolean), uniq_1.default, (0, join_1.default)(', '));
function mapTravelDestinationObjectToCanonical(destination) {
    var _a, _b, _c, _d, _e, _f;
    const { id, name, type, mythosCode, location } = destination;
    let canonicalName = name;
    switch (destination.type) {
        case graphql_types_1.TravelDestinationType.Region:
        case graphql_types_1.TravelDestinationType.Destination:
            canonicalName = (0, exports.concatDestinationSections)([
                name,
                (_a = location === null || location === void 0 ? void 0 : location.country) === null || _a === void 0 ? void 0 : _a.name,
            ]);
            break;
        case graphql_types_1.TravelDestinationType.Resort:
            canonicalName = (0, exports.concatDestinationSections)([
                name,
                (_b = location === null || location === void 0 ? void 0 : location.destination) === null || _b === void 0 ? void 0 : _b.name,
                (_c = location === null || location === void 0 ? void 0 : location.country) === null || _c === void 0 ? void 0 : _c.name,
            ]);
            break;
        case graphql_types_1.TravelDestinationType.Hotel:
            canonicalName = (0, exports.concatDestinationSections)([
                name,
                (_d = location === null || location === void 0 ? void 0 : location.resort) === null || _d === void 0 ? void 0 : _d.name,
                (_e = location === null || location === void 0 ? void 0 : location.destination) === null || _e === void 0 ? void 0 : _e.name,
                (_f = location === null || location === void 0 ? void 0 : location.country) === null || _f === void 0 ? void 0 : _f.name,
            ]);
            break;
    }
    return {
        id,
        name,
        type,
        mythosCode,
        canonicalName,
    };
}
exports.mapTravelDestinationObjectToCanonical = mapTravelDestinationObjectToCanonical;
function mapTravelDestinationObjectToInput(destination) {
    const { id, name, type, mythosCode } = destination;
    return {
        id,
        name,
        type,
        mythosCode,
    };
}
exports.mapTravelDestinationObjectToInput = mapTravelDestinationObjectToInput;
function mapCanonicalDestinationToIDs(destination) {
    return destination.id;
}
exports.mapCanonicalDestinationToIDs = mapCanonicalDestinationToIDs;
function mapCanonicalDestinationToInput(destination) {
    const { id, name, type, mythosCode } = destination;
    return {
        id,
        name,
        type,
        mythosCode,
    };
}
exports.mapCanonicalDestinationToInput = mapCanonicalDestinationToInput;
const mapSearchControlTravelDestinationsToFormTravelDestination = (destinations) => {
    return {
        destinations: destinations === null || destinations === void 0 ? void 0 : destinations.map(mapTravelDestinationObjectToCanonical),
    };
};
exports.mapSearchControlTravelDestinationsToFormTravelDestination = mapSearchControlTravelDestinationsToFormTravelDestination;
const mapFormTravelDestinationToSearchCriteriaInputTravelDestination = (travelDestination) => {
    var _a, _b;
    if (!((_a = travelDestination === null || travelDestination === void 0 ? void 0 : travelDestination.destinations) === null || _a === void 0 ? void 0 : _a.length)) {
        return null;
    }
    return (_b = travelDestination === null || travelDestination === void 0 ? void 0 : travelDestination.destinations) === null || _b === void 0 ? void 0 : _b.map(mapCanonicalDestinationToInput);
};
exports.mapFormTravelDestinationToSearchCriteriaInputTravelDestination = mapFormTravelDestinationToSearchCriteriaInputTravelDestination;
const mapSearchControlTravelDestinationsToSearchCriteriaInputTravelDestinations = (destinations) => {
    // HACK: currently backend has an issue it sends "destinations: []" but expects null as an input
    // for the query which generates url
    if (Array.isArray(destinations) && destinations.length === 0) {
        return null;
    }
    return destinations === null || destinations === void 0 ? void 0 : destinations.map(mapTravelDestinationObjectToInput);
};
exports.mapSearchControlTravelDestinationsToSearchCriteriaInputTravelDestinations = mapSearchControlTravelDestinationsToSearchCriteriaInputTravelDestinations;
const mapCanonicalDestinationToTrackableDestination = (dest) => {
    return {
        id: dest.id,
        label: dest.name,
        type: dest.type,
        mythosCode: dest.mythosCode,
    };
};
exports.mapCanonicalDestinationToTrackableDestination = mapCanonicalDestinationToTrackableDestination;
//# sourceMappingURL=TravelDestination.mappers.js.map